module.exports = __webpack_public_path__ + "static/media/Wordmark_blue-02.1dbe5b07.svg";